import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TenantPickerOption {
    id: string;
    name: string;
    value: string;
    text: string;
    subText?: string;
    description: string;
    warningText?: string;
}

export interface CopilotConfig {
    // Welcome and bot messages
    botWelcomeMessage: string;
    irisBotMessage: string;

    // Suggestions
    botSuggestions: string[];
    promptsSuggestions: string[];

    // UI Configuration
    textBoxLength: number;
    suggestionPopupCharacterThreshold: number;
    suggestionPopupCount: number;
    promptsToShow: number;
    searchCharLimit: number;

    // Feature flags
    isAutoSuggestionEnabled: boolean;
    isResponseSuggestionEnabled: boolean;
    isTypewritingOn: boolean;
    isCreateIncidentButtonVisible: boolean;
    isCopyButtonVisible: boolean;
    isVersionVisible: boolean;
    isPromptButtonVisible: boolean;
    isPromptCoachmarkVisible: boolean;
    isSlashCommandEnabled: boolean;

    // Text labels
    placeholderText: string;
    promptModalTitle: string;
    createSupportTicketButtonText: string;
    featureDescription: string;
    applicationDescription: string;
    featureName: string;

    // Tenant picker configuration
    tenantPickerOptions: TenantPickerOption[];
}

export interface CopilotConfigState {
    config: CopilotConfig | null;
    isLoading: boolean;
    error: string | null;
}

export const initialConfigState: CopilotConfigState = {
    config: null,
    isLoading: false,
    error: null,
};

const copilotConfigSlice = createSlice({
    name: 'copilotConfig',
    initialState: initialConfigState,
    reducers: {
        setConfig: (state, action: PayloadAction<CopilotConfig>) => {
            state.config = action.payload;
            state.error = null;
        },
        setConfigLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setConfigError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        updateBotSuggestions: (state, action: PayloadAction<string[]>) => {
            if (state.config) {
                state.config.botSuggestions = action.payload;
            }
        },
        updatePromptsSuggestions: (state, action: PayloadAction<string[]>) => {
            if (state.config) {
                state.config.promptsSuggestions = action.payload;
            }
        },
    },
});

export const {
    setConfig,
    setConfigLoading,
    setConfigError,
    updateBotSuggestions,
    updatePromptsSuggestions,
} = copilotConfigSlice.actions;

export default copilotConfigSlice.reducer;
